import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { IFiguresAndTablesFile } from '@publishing-engine/domain/models/submission';
import { FormFieldFiguresInput } from '@publishing-engine/domain/types/article';
import { FiguresEmptyState } from './FiguresEmptyState';
import FiguresDisplay from './FiguresDisplay';

interface Props {
  value?: IFiguresAndTablesFile;
  previousValue?: IFiguresAndTablesFile;
  onClose: () => void;
  config: Omit<FormFieldFiguresInput, 'component'>;
}

export const FiguresDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const label = config.params.labels.main;
  const hasPrevious = !!previousValue?.length;
  const hasCurrent = !!value?.length;

  return (
    <DiffModal onClose={onClose}>
      {/* ----- Left side ----- */}
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          {!hasPrevious ? (
            <FiguresEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FiguresDisplay figures={previousValue} />
          )}
        </Flex>
      </DiffModal.LeftSide>

      {/* ----- Right side ----- */}
      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          {!hasCurrent ? (
            <FiguresEmptyState fieldLabels={config.params.labels} />
          ) : (
            <FiguresDisplay figures={value} />
          )}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
